import { TRASH_RETENTION_DAYS } from "@ark/shared";

const MS_PER_DAY = 1000 * 60 * 60 * 24;

export function getDaysRemaining(deletedAt: string | null): number {
  if (!deletedAt) return TRASH_RETENTION_DAYS;
  const elapsedDays = Math.floor((Date.now() - new Date(deletedAt).getTime()) / MS_PER_DAY);
  return Math.max(0, TRASH_RETENTION_DAYS - elapsedDays);
}
